module.exports = __webpack_public_path__ + "media/Ring 7.0f639a22.mp3";